import * as z from "zod";

import { apiTokenIdSchema } from "../shared/api-token";
import { storeIdSchema } from "../shared/store";

export const revokeStoreApiToken = {
  name: "revokeStoreApiToken" as const,
  input: z.object({ storeId: storeIdSchema, tokenId: apiTokenIdSchema }),
  output: z.object({ ok: z.literal(true) }),
};
